import { toast } from 'react-toastify';
import Service from '../../lib/Service';
import { courseActions } from '../ActionTypes';


export const fetchCourses = () => async (dispatch) => {
  try {
    dispatch({
      type: courseActions.COURSES_FETCH_START
    });
    const resData = await Service.GET({
      name: 'course',
      queryString: null
    }).then((res) => {
      if (res.success) {
        return res.data;
      }
      throw new Error(res.message);
    });
    dispatch({
      type: courseActions.COURSES_FETCH_SUCCESS,
      payload: resData
    });
  } catch (error) {
    dispatch({
      type: courseActions.COURSES_FETCH_FAILED,
      payload: { error: error.message }
    });
  }
};

export const saveCourses = (formData) => async (dispatch) => {
  try {
    const payload = {
      ...formData,
      OrderNumber: Number(formData.OrderNumber)
    };
    dispatch({
      type: courseActions.COURSES_SAVE_START
    });
    await Service[formData.Id === '0' ? 'POST' : 'PUT']({
      name: 'course',
      payload
    }).then((res) => {
      if (res.success) {
        return res.data;
      }
      throw new Error(toast.error(res.message));
    });
    dispatch({
      type: courseActions.COURSES_SAVE_SUCCESS
    });
    toast.success('Saved Successfully');
    setTimeout(() => { window.location.href = '/courses'; }, 1000);
  } catch (error) {
    dispatch({
      type: courseActions.COURSES_SAVE_FAILED,
      payload: { formError: error.message }
    });
  }
};

export const editCourses = (coursesId) => async (dispatch, getState) => {
  try {
    const { courseList } = getState().courses;
    const data = courseList.find((item) => item.Id === coursesId);
    if (!data) {
      throw new Error('Something went wrong');
    }
    dispatch({
      type: courseActions.COURSES_SET_FORM,
      payload: { form: data }
    });
  } catch (error) {
    toast.error(error.message);
  }
};

export const resetForm = () => (dispatch) => dispatch({ type: courseActions.COURSES_RESET_FORM });

export const deleteCourses = (Id) => async (dispatch) => Service.DELETE({
  name: 'course',
  payload: { Id }
}).then((res) => {
  if (res.success) {
    dispatch(fetchCourses());
    return true;
  }
  throw new Error(res.message);
});
